'use client';
import React from 'react';

import { useFetchPostComments } from '@/actions/post-comment.actions';
import Typography from '@ui/Typography';
import { cx } from 'cva';
import { LucideLoader } from 'lucide-react';
import PostComment from './PostComment';
import PostCommentForm from './PostCommentForm';

function PostComments(props) {
  const { post, disabled = false, className = '' } = props;

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useFetchPostComments(post);

  const handleLoadMoreComments = async () => {
    if (hasNextPage && !isFetchingNextPage) {
      await fetchNextPage();
    }
  };

  return (
    <div
      className={cx(
        'flex w-full flex-col items-stretch justify-start gap-2',
        className,
      )}>
      {!disabled && (
        <div className="mb-2">
          <PostCommentForm postId={post.id} />
        </div>
      )}
      <div className="flex flex-col gap-2">
        {data?.pages?.map((group, i) => (
          <React.Fragment key={i}>
            {group.comments.map((comment) => (
              <PostComment
                key={comment.id}
                post={post}
                comment={comment}
                disabled={disabled}
              />
            ))}
          </React.Fragment>
        ))}
      </div>

      {hasNextPage && (
        <Typography
          variant="caption"
          component="button"
          className="hover:text-text-hyperlink hover:underline"
          onClick={handleLoadMoreComments}>
          Load more comments
        </Typography>
      )}

      {isFetchingNextPage && (
        <LucideLoader className="h-4 w-4 animate-spin text-text-disabled" />
      )}
    </div>
  );
}

export default PostComments;
